import type { ItemsType } from "../../../../../common-deprecated/redux/typeHelpers";

export const INIT_CAR_ITEMS = "carItems/init" as const;

type InitCarItemsType = { type: typeof INIT_CAR_ITEMS; items: ItemsType };

export const initCarItems = (items: ItemsType): InitCarItemsType => ({ type: INIT_CAR_ITEMS, items });

export type CarItemsActionsType = InitCarItemsType;
